import type { TemplateDoc } from './templates';
import { canonicalTimeZone, isValidLocalDateTime, localToUtc } from './timezone';

const toUtc = (local: string, timeZone: string) => {
    const zone = canonicalTimeZone(timeZone);
    return zone && isValidLocalDateTime(local) ? localToUtc(local, zone) : null;
};

/** The instant a design's countdown counts to, or null when it has no usable target. */
export function countdownTarget(
    doc: TemplateDoc,
    schedule: { endUtc: string | Date } | null,
): Date | null {
    const { countdown } = doc.fields;
    if (!countdown.enabled) return null;
    switch (countdown.target) {
        case 'scheduleEnd':
            return schedule ? new Date(schedule.endUtc) : null;
        case 'eventStart':
            return doc.templateId === 'event'
                ? toUtc(doc.fields.date.start, doc.fields.date.timeZone)
                : null;
        case 'custom':
            return countdown.customAt
                ? toUtc(countdown.customAt.local, countdown.customAt.timeZone)
                : null;
    }
}

export type CountdownParts = { days: number; hours: number; minutes: number; seconds: number };

export function countdownParts(remainingMs: number): CountdownParts {
    const total = Math.max(0, Math.floor(remainingMs / 1000));
    return {
        days: Math.floor(total / 86_400),
        hours: Math.floor((total % 86_400) / 3_600),
        minutes: Math.floor((total % 3_600) / 60),
        seconds: total % 60,
    };
}
